

export const servicePlanNoTrunkFilter = (value) => {
    return !value.no_trunk
};


export const uniqueArrayFilter = (value, index, array) => {
    return array.indexOf(value) === index;
};

export const readSavedFilters = (storageKey = null) => {
    try {
        const saved = storageKey ? JSON.parse(localStorage.getItem(storageKey)) : null;
        return saved || {};
    } catch (e) {
        return {};
    }
};